// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"fc64f572","644":"d0b5df69"}[chunkId] + ".chunk.js";
};